(()=>{
  if(window.__vivaAskRuntimeGuard)return;
  window.__vivaAskRuntimeGuard=true;
  const nativeFetch=window.fetch.bind(window);
  const HARD_WAIT_MS=360000;
  const isAskUrl=url=>/\/api\/ask-viva(?:\?|$)/.test(String(url||''));
  const setTimeoutMessage=()=>{
    const status=document.querySelector('[data-viva-ask-root] [data-viva-status]');
    if(!status)return;
    const message='This preview exceeded the safe processing window and was stopped. No unverified image was shown.';
    if(status.textContent!==message)status.textContent=message;
    if(status.dataset.state!=='error')status.dataset.state='error';
    status.dataset.vivaTechnicalReason='CLIENT_TIMEOUT';
  };
  window.fetch=async(input,init={})=>{
    const url=typeof input==='string'?input:input?.url||'';
    if(!isAskUrl(url))return nativeFetch(input,init);
    const controller=new AbortController();
    const originalSignal=init?.signal||(typeof Request!=='undefined'&&input instanceof Request?input.signal:null);
    const forwardAbort=()=>controller.abort(originalSignal?.reason);
    if(originalSignal){
      if(originalSignal.aborted)forwardAbort();
      else originalSignal.addEventListener('abort',forwardAbort,{once:true});
    }
    let timedOut=false;
    const timer=setTimeout(()=>{timedOut=true;controller.abort('CLIENT_TIMEOUT');},HARD_WAIT_MS);
    try{
      return await nativeFetch(input,{...init,signal:controller.signal});
    }catch(error){
      if(timedOut)setTimeout(setTimeoutMessage,0);
      throw error;
    }finally{
      clearTimeout(timer);
      if(originalSignal)originalSignal.removeEventListener('abort',forwardAbort);
    }
  };
})();
